// Viewing intent expires server-side even if a tab crashes or mobile suspends it.
export function startPrinterMonitor({ renew, visible, subscribe, onError }: {
 renew: () => Promise<unknown>; visible: () => boolean;
 subscribe: (listener: () => void) => () => void; onError: (error: string) => void;
}) {
 let stopped = false, inFlight = false;
 const tick = async () => {
  if (stopped || inFlight || !visible()) return;
  inFlight = true;
  try { await renew(); if (!stopped) onError(''); }
  catch (error) { if (!stopped) onError((error as Error).message); }
  finally { inFlight = false; }
 };
 const unsubscribe = subscribe(() => { void tick(); });
 const timer = setInterval(() => { void tick(); }, 10_000);
 void tick();
 return () => { stopped = true; clearInterval(timer); unsubscribe(); };
}
